import { useState } from "react";
import { useNavigate } from "react-router-dom";

const initialForm = {
  name: "",
  email: "",
  topic: "General question",
  message: "",
};

export default function ContactSupport() {
  const navigate = useNavigate();
  const [form, setForm] = useState(initialForm);
  const [touched, setTouched] = useState({});
  const [status, setStatus] = useState({ loading: false, ok: null, msg: "" });
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const errors = {
    name: !form.name.trim() ? "Enter a name" : "",
    email: !form.email.trim() ? "Enter your email address." : !/^\S+@\S+\.\S+$/.test(form.email.trim()) ? "Incorrect email" : "",
    message: !form.message.trim() ? "Enter a message" : "",
  };

  function handleChange(e) {
    const { name, value } = e.target;
    setForm((current) => ({ ...current, [name]: value }));
    setStatus({ loading: false, ok: null, msg: "" });
  }

  function handleBlur(e) {
    setTouched((current) => ({ ...current, [e.target.name]: true }));
  }

  function returnToHome() {
    setShowSuccessModal(false);
    navigate("/");
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setTouched({ name: true, email: true, message: true });

    if (errors.name || errors.email || errors.message) {
      return;
    }

    try {
      setStatus({ loading: true, ok: null, msg: "" });

      const payload = new FormData();
      payload.append("form", "support");
      payload.append("name", form.name.trim());
      payload.append("email", form.email.trim());
      payload.append("topic", form.topic);
      payload.append("message", form.message.trim());

      const res = await fetch("/idealwells-api/forms/support", {
        method: "POST",
        body: payload,
      });

      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || "Server error");
      }

      setForm(initialForm);
      setTouched({});
      setStatus({ loading: false, ok: true, msg: "" });
      setShowSuccessModal(true);
    } catch (err) {
      setStatus({ loading: false, ok: false, msg: "Failed to send. Please try again later." });
    }
  }

  return (
    <section className="page-shell support-page">
      <div className="container">
        <div className="page-shell__content">
          <p className="page-eyebrow">Support</p>
          <h1>Contact Support</h1>
          <p className="page-lead">
            Send a question about uploads, file formats, request status, or digitization outputs.
          </p>

          <form className="support-form" onSubmit={handleSubmit} noValidate>
            <div className="row g-3">
              <div className="col-md-6">
                <label className="form-label">YOUR NAME</label>
                <input
                  className={`form-control ${touched.name && errors.name ? "is-invalid" : touched.name ? "is-valid" : ""}`}
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Full name"
                  required
                />
                <div className="invalid-feedback">{errors.name}</div>
              </div>

              <div className="col-md-6">
                <label className="form-label">YOUR EMAIL</label>
                <input
                  className={`form-control ${touched.email && errors.email ? "is-invalid" : touched.email ? "is-valid" : ""}`}
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="work@company.com"
                  required
                />
                <div className="invalid-feedback">{errors.email}</div>
              </div>

              <div className="col-md-12">
                <label className="form-label">TOPIC</label>
                <select
                  className="form-control"
                  name="topic"
                  value={form.topic}
                  onChange={handleChange}
                >
                  <option>General question</option>
                  <option>Upload problem</option>
                  <option>Digitization result</option>
                  <option>Billing or account</option>
                </select>
              </div>

              <div className="col-md-12">
                <label className="form-label">MESSAGE</label>
                <textarea
                  className={`form-control ${touched.message && errors.message ? "is-invalid" : touched.message ? "is-valid" : ""}`}
                  name="message"
                  value={form.message}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Describe how we can help."
                  required
                ></textarea>
                <div className="invalid-feedback">{errors.message}</div>
              </div>
            </div>

            <button className="btn btn-primary btn-lg mt-3" type="submit" disabled={status.loading}>
              {status.loading ? "Sending..." : "Send support request"}
            </button>

            {status.msg && (
              <div className={`alert mt-3 ${status.ok ? "alert-success" : "alert-danger"}`} role="alert" aria-live="polite">
                {status.msg}
              </div>
            )}
          </form>
        </div>
      </div>
      {showSuccessModal && (
        <div className="success-modal-backdrop">
          <div
            className="success-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="support-success-modal-title"
          >
            <div className="success-modal__icon" aria-hidden="true">
              <span>&#10003;</span>
            </div>
            <h3 id="support-success-modal-title">Support Request Sent!</h3>
            <div className="success-modal__divider"></div>
            <p>
              Our team will review everything and get back to you shortly.
            </p>
            <button className="success-modal__button" type="button" onClick={returnToHome}>
              Return to Home
            </button>
          </div>
        </div>
      )}
    </section>
  );
}
